import { VOCAB_URL } from 'app/constants/api.constants'
import routesConstants from 'app/constants/routes.constants'

import {
  bibliotecaIcon,
  blueBook,
  caminosBibliotecaIcon,
  knowledgeBuilderIcon,
  library3Icon,
  libraryIcon,
  purpleBook,
  sonidosIcon,
  soundsIcon,
  vocabIcon,
} from 'app/components/home/home-content-buttons/assets'
import {
  HOME_LINKS_ID,
  PROGRAM_FILTERS,
} from 'app/constants/home-links.constants'
import { LANGUAGE } from 'app/constants/language.constants'
import { GRADES } from 'app/types/grades.types'

export const knowledgeBuilder = {
  id: HOME_LINKS_ID.KNOWLEDGE_BUILDERS,
  imageSrc: knowledgeBuilderIcon,
  backgroundColor: '#E15080',
  text: 'Knowledge Builders',
  href: routesConstants.THEATER,
  language: LANGUAGE.EN,
}

export const sonidos = {
  id: HOME_LINKS_ID.SONIDOS,
  imageSrc: sonidosIcon,
  backgroundColor: '#54995B',
  text: 'Sonidos',
  href: routesConstants.SONIDOS,
  language: LANGUAGE.ES,
}

export const sounds = {
  id: HOME_LINKS_ID.SOUNDS,
  imageSrc: soundsIcon,
  backgroundColor: '#834dd1',
  text: 'Sounds',
  href: routesConstants.SOUNDS,
  language: LANGUAGE.EN,
}

export const library = {
  id: HOME_LINKS_ID.LIBRARY,
  imageSrc: libraryIcon,
  backgroundColor: '#209ED3',
  text: 'Library',
  href: routesConstants.LIBRARY,
  language: LANGUAGE.EN,
}

export const library3 = {
  id: HOME_LINKS_ID.LIBRARY3,
  imageSrc: library3Icon,
  backgroundColor: '#209ED3',
  text: 'Library',
  href: routesConstants.LIBRARY3,
  language: LANGUAGE.EN,
}

export const vocab = {
  id: HOME_LINKS_ID.VOCAB,
  imageSrc: vocabIcon,
  backgroundColor: '#7B4BD7',
  text: 'Vocab',
  href: VOCAB_URL,
  external: true,
  language: LANGUAGE.EN,
}

export const biblioteca = {
  id: HOME_LINKS_ID.BIBLIOTECA,
  imageSrc: bibliotecaIcon,
  backgroundColor: '#EB5263',
  text: 'Biblioteca',
  href: routesConstants.BIBLIOTECA,
  language: LANGUAGE.EN,
}

export const caminosBiblioteca = {
  id: HOME_LINKS_ID.CAMINOS_BIBLIOTECA,
  imageSrc: caminosBibliotecaIcon,
  backgroundColor: '#EB5263',
  text: 'Biblioteca',
  href: routesConstants.CAMINOS,
  language: LANGUAGE.ES,
}

export const texasElar = {
  id: HOME_LINKS_ID.TEXAS_ELAR,
  imageSrc: purpleBook,
  backgroundColor: '#209ED3',
  text: 'Library',
  href: routesConstants.TEXAS_ELAR,
  language: LANGUAGE.EN,
}

export const texasSlar = {
  id: HOME_LINKS_ID.TEXAS_SLAR,
  imageSrc: blueBook,
  backgroundColor: '#EB5263',
  text: 'Biblioteca',
  href: routesConstants.TEXAS_SLAR,
  language: LANGUAGE.ES,
}

const caminosElementarySchoolLinks = [sonidos, caminosBiblioteca]
const middleSchoolLinks = [vocab, library]

export const appLinks = {
  [GRADES.KINDERGARTEN]: {
    [PROGRAM_FILTERS.CKLA]: [knowledgeBuilder, sounds, library],
    [PROGRAM_FILTERS.CKLA3]: [library3, sounds],
    [PROGRAM_FILTERS.CAMINOS]: [...caminosElementarySchoolLinks],
    [PROGRAM_FILTERS.TEXAS_ELAR]: [sounds, texasElar],
    [PROGRAM_FILTERS.TEXAS_SLAR]: [sonidos, texasSlar],
    [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: [sounds],
    [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: [sonidos],
    [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: [sounds, sonidos],
  },
  [GRADES.FIRST_GRADE]: {
    [PROGRAM_FILTERS.CKLA]: [knowledgeBuilder, sounds, library],
    [PROGRAM_FILTERS.CKLA3]: [library3, sounds],
    [PROGRAM_FILTERS.CAMINOS]: [...caminosElementarySchoolLinks],
    [PROGRAM_FILTERS.TEXAS_ELAR]: [sounds, texasElar],
    [PROGRAM_FILTERS.TEXAS_SLAR]: [sonidos, texasSlar],
    [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: [sounds],
    [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: [sonidos],
    [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: [sounds, sonidos],
  },
  [GRADES.SECOND_GRADE]: {
    [PROGRAM_FILTERS.CKLA]: [knowledgeBuilder, sounds, library],
    [PROGRAM_FILTERS.CKLA3]: [library3, sounds],
    [PROGRAM_FILTERS.CAMINOS]: [...caminosElementarySchoolLinks],
    [PROGRAM_FILTERS.TEXAS_ELAR]: [sounds, texasElar],
    [PROGRAM_FILTERS.TEXAS_SLAR]: [sonidos, texasSlar],
    [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: [sounds],
    [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: [sonidos],
    [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: [sounds, sonidos],
  },
  [GRADES.THIRD_GRADE]: {
    [PROGRAM_FILTERS.CKLA]: [...middleSchoolLinks, biblioteca],
    [PROGRAM_FILTERS.CKLA3]: [vocab, library3],
    [PROGRAM_FILTERS.CAMINOS]: [caminosBiblioteca],
    [PROGRAM_FILTERS.TEXAS_ELAR]: [texasElar],
    [PROGRAM_FILTERS.TEXAS_SLAR]: [texasSlar],
    [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: [],
    [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: [],
    [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: [texasElar, texasSlar],
  },
  [GRADES.FOURTH_GRADE]: {
    [PROGRAM_FILTERS.CKLA]: [...middleSchoolLinks, biblioteca],
    [PROGRAM_FILTERS.CKLA3]: [vocab, library3],
    [PROGRAM_FILTERS.CAMINOS]: [caminosBiblioteca],
    [PROGRAM_FILTERS.TEXAS_ELAR]: [texasElar],
    [PROGRAM_FILTERS.TEXAS_SLAR]: [texasSlar],
    [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: [],
    [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: [],
    [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: [texasElar, texasSlar],
  },
  [GRADES.FIFTH_GRADE]: {
    [PROGRAM_FILTERS.CKLA]: [...middleSchoolLinks, biblioteca],
    [PROGRAM_FILTERS.CKLA3]: [vocab, library3],
    [PROGRAM_FILTERS.CAMINOS]: [caminosBiblioteca],
    [PROGRAM_FILTERS.TEXAS_ELAR]: [texasElar],
    [PROGRAM_FILTERS.TEXAS_SLAR]: [texasSlar],
    [PROGRAM_FILTERS.TEXAS_IMRA_ELAR]: [],
    [PROGRAM_FILTERS.TEXAS_IMRA_SLAR]: [],
    [PROGRAM_FILTERS.TEXAS_IMRA_COMMERCIAL]: [texasElar, texasSlar],
  },
}

export const allowedBibliotecaAndSpanishReaderGrades = [
  GRADES.THIRD_GRADE,
  GRADES.FOURTH_GRADE,
  GRADES.FIFTH_GRADE,
]

export const allowedSoundsAndSonidosGrades = [
  GRADES.KINDERGARTEN,
  GRADES.FIRST_GRADE,
  GRADES.SECOND_GRADE,
]

export const allowedTheaterGrades = [
  GRADES.KINDERGARTEN,
  GRADES.FIRST_GRADE,
  GRADES.SECOND_GRADE,
]
